import { z } from 'zod';
export const PUSH_CATEGORIES = ['deals', 'eventReminders', 'activity'];
export const PUSH_TARGET_TYPES = ['venue', 'event'];
export const DEFAULT_NOTIFICATION_PREFERENCES = {
    enabled: true,
    deals: true,
    eventReminders: true,
    activity: true,
};
/** Merges stored (possibly missing/partial) preferences over the all-true defaults. */
export const resolveNotificationPreferences = (p) => ({
    enabled: p?.enabled ?? DEFAULT_NOTIFICATION_PREFERENCES.enabled,
    deals: p?.deals ?? DEFAULT_NOTIFICATION_PREFERENCES.deals,
    eventReminders: p?.eventReminders ?? DEFAULT_NOTIFICATION_PREFERENCES.eventReminders,
    activity: p?.activity ?? DEFAULT_NOTIFICATION_PREFERENCES.activity,
});
export const PUSH_TITLE_MAX = 65;
export const PUSH_BODY_MAX = 178;
export const pushTitleSchema = z.string().trim().min(1).max(PUSH_TITLE_MAX);
export const pushBodySchema = z.string().trim().min(1).max(PUSH_BODY_MAX);
export const pushTargetSchema = z.object({
    type: z.enum(PUSH_TARGET_TYPES),
    id: z.string().regex(/^[a-f0-9]{24}$/i, 'Invalid id'),
});
export const PUSH_CATEGORY_LABELS = {
    deals: 'Deals & events near you',
    eventReminders: "Reminders for events I've signed up for",
    activity: 'Activity on my content',
};
export const DEFAULT_VENUE_PUSH_MONTHLY_LIMIT = 4;
export const startOfUtcMonth = (d) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1));
export const startOfNextUtcMonth = (d) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 1));
